import React, { useEffect, useState } from "react";
import {
  EditOutlined,
  DeleteOutlined,
  ExclamationCircleOutlined,
} from "@ant-design/icons";
import {
  Layout,
  List,
  PageHeader,
  Space,
  Button,
  Image,
  Select,
  Modal,
  Row,
} from "antd";

import styles from "./style.module.scss";
import R2Footer from "../../../components/Footer";
import {
  deleteCertificate,
  getCertificates,
  getRestaurants,
} from "../../../services/CertificateService";
import AddCertificate from "./AddCertification";

const { Content } = Layout;
const { Option } = Select;
const { confirm } = Modal;

const IconText = ({ icon, text }) => (
  <Space>
    {React.createElement(icon)}
    {text}
  </Space>
);



const Certifications = () => {
  const [visibleDrawer, setVisibleDrawer] = useState(false);
  const [selectedCertificate, setSelectedCertificate] = useState(null);
  const [restaurants, setRestaurants] = useState([]);
  const [certifications, setCertifications] = useState([]);
  const [filteredList, setFilteredList] = useState([]);
  const [isEdit, setEdit] = useState(false);

  useEffect(() => {
    getCertificatesItems();
    getRestaurants().then((res) => setRestaurants(res.restaurants));
  }, []);

  const getCertificatesItems = async () => {
    const data = await getCertificates();
    setCertifications(data?.certifications || []);
    setFilteredList(data?.certifications || []);
  };

  const filterData = (val) => {
    setFilteredList(
      val
        ? certifications.filter((c) => c.restaurant_id === val)
        : certifications
    );
  };

  const handleDelete = (item) => {
    confirm({
      title: "Do you Want to delete this item?",
      icon: <ExclamationCircleOutlined />,
      content: item.name,
      onOk() {
        deleteCertificate(item.id);
        getCertificatesItems();
      },
    });
  };

  const closeModal = () => {
    setVisibleDrawer(false);
    
  };

  const onAddorUpdate = () => {
    getCertificatesItems();
    setCertifications(null)
    setVisibleDrawer(false);
  }

  return (
    <Layout className="u-page-layout">
      <Content>
        <Space
          direction="vertical"
          style={{
            width: "100%",
          }}
        >
          <PageHeader
           className="page-header-business"
            extra={[
              <Row gutter={[16,16]}>
              <div className={styles.filterRow}>
                <span>Filter by restaurant:&nbsp;&nbsp;</span>
                <Select
                  defaultValue={null}
                  placeholder="Please choose restaurant"
                  onChange={filterData}
                  style={{ minWidth: 200 }}
                >
                  <Option value={null}>All</Option>
                  {restaurants.map((res) => (
                    <Option key={res.id} value={res.id}>
                      {res.name}
                    </Option>
                  ))}
                </Select>
              </div>,
              <Button
                type="primary"
                className="custom-btn"
                onClick={setVisibleDrawer}
              >
                Add Certifications
              </Button>,
              </Row>
            ]}
            title=" Awards / Certifications"
          />

          <div className="text-left content-container-business">
            <List
              itemLayout="vertical"
              size="large"
              dataSource={filteredList}
              renderItem={(item, i) => (
                <List.Item
                  key={i}
                  className={styles.listItem}
                  actions={[
                    <Button
                      type="text"
                      onClick={() => {
                        setSelectedCertificate(item);
                        setEdit(true);
                        setVisibleDrawer(true);
                      }}
                      className={styles.pl0}
                    >
                      <IconText
                        icon={EditOutlined}
                        text="Edit"
                        key="list-vertical-star-o"
                      />
                    </Button>,
                    <Button type="text" onClick={() => handleDelete(item)}>
                      <IconText
                        icon={DeleteOutlined}
                        text="Delete"
                        key="list-vertical-like-o"
                      />
                    </Button>,
                  ]}
                  extra={<Image width={150} src={item.photo_url} />}
                >
                  <List.Item.Meta title={item.name} />
                </List.Item>
              )}
            />
          </div>
          <R2Footer />
        </Space>
      </Content>
      <AddCertificate
        modalOpen={visibleDrawer}
        isEdit={isEdit}
        closeModal={closeModal}
        onAddorUpdate={onAddorUpdate}
        selectedCertificate={selectedCertificate}
      />
    </Layout>
  );
};

export default Certifications;
